import * as React from 'react';

export class AppHeader extends React.Component {
  public render() {
    return (
      <div className="app-header">
        <a href="https://www.volaris.com/" target="_blank">
          <img src="/assets/images/volaris-mobile-logo1.png"/>
        </a>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/components/app/app-header.tsx